<template>
    
    <v-expansion-panels accordion v-model="expanded">
        <v-expansion-panel v-if="canAdd">
            <v-expansion-panel-header>Add New Analysis</v-expansion-panel-header>
            <v-expansion-panel-content>
                <AddVenomAnalysis
                    :specimenID="specimenID"
                    :dailyExtractionID="dailyExtractionID"
                    :monthlyPoolID="monthlyPoolID"
                    :venomLotID="venomLotID"
                    :speciesBatchPoolID="speciesBatchPoolID"
                    @created="venomAnalysisCreated"></AddVenomAnalysis>
            </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
            <v-expansion-panel-header>Existing Analysis</v-expansion-panel-header>
            <v-expansion-panel-content>
                <HistoricalAnalysis
                    ref="historicalAnalysis"
                    :specimenID="specimenID"
                    :dailyExtractionID="dailyExtractionID"
                    :monthlyPoolID="monthlyPoolID"
                    :venomLotID="venomLotID"
                    :speciesBatchPoolID="speciesBatchPoolID">
                </HistoricalAnalysis>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>
import AddVenomAnalysis from "./AddVenomAnalysis"
import HistoricalAnalysis from "./HistoricalAnalysis"

export default {
    components: {
        AddVenomAnalysis,
        HistoricalAnalysis
    },
    props: {
        canAdd: {
            type: Boolean,
            default: true
        },
        specimenID: {
            type: Number,
            default: -1
        },
        dailyExtractionID: {
            type: Number,
            default: -1
        },
        monthlyPoolID: {
            type: Number,
            default: -1
        },
        venomLotID: {
            type: Number,
            default: -1
        },
        speciesBatchPoolID: {
            type: Number,
            default: -1
        }
    },
    data() {
        return {
            expanded: 0
        };
    },
    methods: {
        venomAnalysisCreated() {
            if(this.$refs.historicalAnalysis!==null && this.$refs.historicalAnalysis !== undefined){
                this.$refs.historicalAnalysis.loadAnalysis();
            }
            
        }
    },
    async created() {
    }
}
</script>